/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './RoomInfo.css';

import {
} from '../../actions';


class RoomInfo extends Component {
  render() {
    let room = this.props.room;
    if (!room) return null;
    let location = room.location;

    let searchUrl;
    if (room.location) {
      searchUrl = '/s?city=' + encodeURIComponent(room.location.city.fullName) + '&room=' + room.name;
    } else {
      searchUrl = '/s';
    }

    let roomUrl = '/r/' + room.slug + '/' + room.id;

    return (
      <div className="RoomInfo">
        <div className="room-name">{room.name}</div>
        <div className="room-location">
          <span className="room-company">{room.location && room.location.company}, </span>
          <span className="room-city">{room.location && room.location.city.fullName}</span>
        </div>
        <div className="room-address">{room.location && room.location.address}</div>
        <div className="room-decription">{room.description}</div>
        <div className="room-num-players">
          {!!(room.minPeople && room.maxPeople) && <span>{room.minPeople}-{room.maxPeople} players</span>}
          {!!room.minutes && <span>, {room.minutes} minutes</span>}
        </div>
        <div className="controls">
          <Link to={roomUrl}><Button bsSize="small">More Info</Button></Link>{' '}
          <Link to={searchUrl}><Button bsSize="small">See Available Times</Button></Link>{' '}
          {room.url && <a href={room.url} rel="nofollow" className="btn btn-default" target="_blank">Visit Room Website</a>}
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoomInfo);



/** WEBPACK FOOTER **
 ** ./src/components/partials/RoomInfo.js
 **/